import PropTypes from 'prop-types';

export const SubLenderShape = PropTypes.shape({
  firstName: PropTypes.string,
  surname: PropTypes.string,
});
